module.exports = __webpack_public_path__ + "img/arrow-yellow.7b453535.svg";